import { CONDITIONS, CONDITION_NAME, OPERATORS, VALUES } from "../misc/constants";

import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";

export const decoColumns = ({ handleRowActions }) => {

    return [
        {
            name    : "Goal Name",
            selector: (row) => row.name,
            width   : "300px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    className="text-primary"
                    id={`life-cycle-${row._id}`}
                    max={20}/>
            )
        },
        {
            name    : "Condition",
            selector: (row) => row.conditions[0].condition,
            width   : "150px",
            cell    : row => (CONDITIONS("goal").find((item) => item.value === row.conditions[0].condition)?.label || "-")
                
        },
        {
            name    : "Condition Name",
            selector: (row) => row.conditions[0].name,
            width   : "200px",
            cell    : row => (CONDITION_NAME(row.conditions[0].condition).find((item) => item.value === row.conditions[0].name)?.label || "-")

        },
        {
            name    : "Operator",
            selector: (row) => row.conditions[0].operator,
            width   : "200px",
            cell    : row => (OPERATORS.find((item) => item.value === row.conditions[0].operator)?.label || "-")
        },
        {
            name    : "Value",
            selector: (row) => row.conditions[0].value,
            width   : "250px",
            cell    : row => (VALUES(row.conditions[0].name).find((item) => item.value === row.conditions[0].value)?.label || row.conditions[0].value)
        },
        {
            name: "Actions",
            cell: row => (
                <>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        id={`${row._id}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};